import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import Notification from 'bundles/notification-center/components/Notification';
import type {
  DiscussionForumNewAnswerForFollowerNotification as DiscussionForumNewAnswerForFollowerNotificationType,
  Notification as NotificationType,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: DiscussionForumNewAnswerForFollowerNotificationType;
  rank?: number;
  onClick: (notification: NotificationType) => void;
};

const DiscussionForumNewAnswerForFollowerNotification = ({
  notification,
  rank,
  onClick,
  notification: {
    data: { course, redirectUrlOnClick },
  },
}: Props) => (
  <Notification onClick={onClick} href={redirectUrlOnClick} notification={notification} rank={rank}>
    <FormattedHTMLMessage
      message={_t(`Somebody commented in a thread in {courseName}`)}
      courseName={course.name}
      tagName="span"
    />
  </Notification>
);

export default DiscussionForumNewAnswerForFollowerNotification;
